import React, { useState, useEffect } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const navLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Programs", to: "/programs" },
  { label: "Pricing", to: "/pricing" },
  { label: "Gallery", to: "/gallery" },
  { label: "Contact", to: "/contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Close the mobile menu whenever the route changes.
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const isActive = (to) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header className="fixed top-0 left-0 w-full z-50 glass border-b border-accent/20">
      <nav className="container mx-auto px-6 py-3.5 flex justify-between items-center">
        <RouterLink to="/" aria-label="Yogarambh Wellness home">
          <Logo />
        </RouterLink>

        {/* Desktop menu */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <RouterLink
              key={l.to}
              to={l.to}
              className={`text-sm font-medium transition-colors ${
                isActive(l.to)
                  ? "text-primary"
                  : "text-charcoal/70 hover:text-primary"
              }`}
            >
              {l.label}
            </RouterLink>
          ))}
          <RouterLink
            to="/contact"
            className="px-6 py-2.5 bg-primary text-white rounded-full font-semibold text-sm shadow-soft hover:bg-primary-dark hover:-translate-y-0.5 transition-all duration-300"
          >
            Book Now
          </RouterLink>
        </div>

        {/* Mobile toggle */}
        <button
          type="button"
          className="md:hidden text-charcoal p-1"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-cream/95 backdrop-blur-lg border-t border-accent/20 px-6 py-4 flex flex-col gap-1">
          {navLinks.map((l) => (
            <RouterLink
              key={l.to}
              to={l.to}
              className={`py-2.5 text-sm font-medium transition-colors ${
                isActive(l.to)
                  ? "text-primary"
                  : "text-charcoal/80 hover:text-primary"
              }`}
            >
              {l.label}
            </RouterLink>
          ))}
          <RouterLink
            to="/contact"
            className="mt-2 py-3 px-6 text-center bg-primary text-white rounded-full font-semibold text-sm shadow-soft hover:bg-primary-dark transition-all"
          >
            Book Now
          </RouterLink>
        </div>
      )}
    </header>
  );
};

export default Header;
